import Vue from 'vue'
import Vuex from 'vuex'
import {loading} from '@/modules/loading/loading'
import {alert} from '@/modules/alert/alert';
import {company} from '@/modules/company/company'
import {supplier} from '@/modules/supplier/supplier'
import {agent} from '@/modules/agent/agent'
import {purchase} from "@/modules/purchase/purchase";
import {agreement_group} from '@/modules/agreement_group/agreement_group';
import {material_declaration} from "@/modules/material_declaration/material_declaration";
import {product_specific_rule} from "@/modules/product_specific_rule/product_specific_rule";
import { material_declaration_transaction } from '@/modules/material_declaration_transaction/material_declaration_transaction';
import {user} from '@/modules/user/user';
import {reset_password_email} from "@/modules/reset_password_email/reset_password_email"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    version: '1.0.0', // a simple property
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    loading,
    alert,
    company,
    supplier,
    agent,
    purchase,
    agreement_group,
    product_specific_rule,
    material_declaration,
    material_declaration_transaction,
    user,
    reset_password_email
  }
})
